// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function AIHotkeysSlide() {
  return (
    <div className="slide-content feature-slide">
      <div className="feature-demo">
        <div className="feature-highlights">
          <div className="highlight">Ask, Define, Summarize, Rewrite, Critique, Translate, Plan</div>
          <div className="highlight">Local leader key: <kbd>Ctrl+Win+Alt+L</kbd></div>
          <div className="highlight">Cloud leader key: <kbd>Ctrl+Win+Alt+A</kbd></div>
          <div className="highlight">Works on selected text in any app</div>
          <div className="highlight">Actions are fully customizable</div>
        </div>
      </div>

      <div className="feature-header">
        <div className="feature-category">AI Hotkeys+</div>
        <h2 className="slide-title">Ask, summarize, or rewrite — instantly, anywhere</h2>
        <p className="slide-text">
          Select any text and trigger an AI action with a hotkey. Choose a fully local model
          for complete privacy, or send to the cloud when you need it — your choice, every time.
        </p>
      </div>
    </div>
  )
}

export default AIHotkeysSlide
